import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface HelpBreadcrumbProps {
  items: BreadcrumbItem[];
}

export function HelpBreadcrumb({ items }: HelpBreadcrumbProps) {
  return (
    <nav className="flex items-center flex-wrap gap-y-1 text-sm mb-6">
      <Link
        to="/help"
        className="flex items-center text-gray-500 hover:text-violet-600 transition-colors"
      >
        <Home className="w-4 h-4" />
        <span className="ml-1.5 hidden sm:inline">Help Center</span>
      </Link>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="w-4 h-4 mx-1.5 sm:mx-2 text-gray-300 flex-shrink-0" />
          {item.href ? (
            <Link
              to={item.href}
              className="text-gray-500 hover:text-violet-600 transition-colors truncate max-w-[150px] sm:max-w-none min-w-0"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-900 font-medium truncate sm:line-clamp-2 max-w-[200px] sm:max-w-none min-w-0">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
